import React from 'react';
import { Provider } from 'react-redux';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import {
  AnimatedCoins,
  Box,
  ThemeProvider,
  toastConfig,
} from '@betty/moonlight';
import { PersistGate } from '@betty/toolkit/state';
import { SplashScreen } from '@betty/navigation';
import router from './Router';

import { persistor, store } from '@betty/toolkit/store';
import { HelmetProvider } from 'react-helmet-async';
import Toast from 'react-native-toast-message';

import './modals';
import { RouterProvider } from 'react-router';

function App() {
  return (
    <HelmetProvider>
      <GestureHandlerRootView>
        <SafeAreaProvider>
          <ThemeProvider>
            <Provider store={store}>
              <PersistGate loading={<SplashScreen />} persistor={persistor}>
                <RouterProvider router={router} />
              </PersistGate>
            </Provider>
            <Box position="absolute" top="space-0" width="100%" zIndex={3}>
              <Toast config={toastConfig} autoHide visibilityTime={4000} />
            </Box>
            <AnimatedCoins />
          </ThemeProvider>
        </SafeAreaProvider>
      </GestureHandlerRootView>
    </HelmetProvider>
  );
}

export default App;
